export default "__VITE_ASSET__Ce7wOJ74__"